import { AuthenticationService } from "../authentication";

export class BackendGatewayApiService {
  private static instance: BackendGatewayApiService;
  private baseUrl: string;

  private constructor() {
    this.baseUrl = import.meta.env.VITE_BACKEND_GATEWAY_URL || "http://localhost:3000";
  }

  public static getInstance(): BackendGatewayApiService {
    if (!BackendGatewayApiService.instance) {
      BackendGatewayApiService.instance = new BackendGatewayApiService();
    }
    return BackendGatewayApiService.instance;
  }

  /**
   * Make authenticated API requests using JWT token
   */
  async makeRequest(endpoint: string, options: RequestInit = {}): Promise<Response> {
    const url = `${this.baseUrl}${endpoint}`;
    const authService = AuthenticationService.getInstance();

    // Use the authentication service to make the request with JWT token
    return authService.makeAuthenticatedRequest(url, options);
  }

  /**
   * Make GraphQL requests using JWT authentication
   */
  async makeGraphQLRequest(query: string, variables?: Record<string, unknown>): Promise<Response> {
    const authService = AuthenticationService.getInstance();

    const graphqlEndpoint = `${this.baseUrl}/graphql`;

    return authService.makeAuthenticatedRequest(graphqlEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query,
        variables,
      }),
    });
  }

  /**
   * Health check endpoint
   */
  async healthCheck(): Promise<boolean> {
    try {
      const response = await this.makeRequest("/health");
      return response.ok;
    } catch (error) {
      console.error("Health check failed:", error);
      return false;
    }
  }
}

export const backendGatewayApiService = BackendGatewayApiService.getInstance();
